{
  "seo": {
    "title": "Quiz Time",
    "description": "Take a quick quiz to test what you've learned on CuriPop."
  },
  "loading": "Loading quiz…",
  "title": "Quiz Time",
  "locked": {
    "subtitle": "Quizzes are included with the Family plan. Subscribe to unlock the full quiz experience.",
    "cta": "See plans",
    "pathStepTitle": "Step locked",
    "pathStepSubtitle": "Finish the earlier steps in this learning path first, then come back to this one.",
    "pathStepCta": "Back to path"
  },
  "linkedBadge": "{category} · {mode}",
  "intro": {
    "subtitle": "Pick a challenge and collect badges as you go.",
    "categoryLabel": "Category (optional)",
    "categoryAria": "Category",
    "allCategories": "All categories"
  },
  "modes": {
    "easy": {
      "label": "Easy",
      "blurb": "10 questions · 3 choices · 3 hearts"
    },
    "normal": {
      "label": "Normal",
      "blurb": "10 questions · 4 choices · 3 hearts"
    },
    "hard": {
      "label": "Hard",
      "blurb": "10 questions · 5 choices · 3 hearts"
    }
  },
  "empty": {
    "subtitle": "We do not have enough quiz questions yet. Please check back soon.",
    "explore": "Explore questions",
    "changeMode": "Change mode",
    "backToPath": "Back to path"
  },
  "failed": {
    "title": "Out of hearts",
    "subtitle": "Take a breather and try again when you're ready.",
    "retry": "Retry",
    "explore": "Explore questions",
    "backToPath": "Back to path"
  },
  "complete": {
    "title": "Round complete!",
    "subtitle": "You did it! Ready for another round?",
    "playAgain": "Play Again",
    "back": "Back to Quiz",
    "backToPath": "Back to path",
    "continueTitle": "Nice work!",
    "continueSubtitle": "Ready for the next step?",
    "continueCta": "Continue",
    "pathCompleteTitle": "You beat it!",
    "pathCompleteSubtitle": "That's the whole path finished. Head back to see your progress.",
    "pathCompleteCta": "Back to Learning Path",
    "reviewTitle": "Wrong answer review ({count})",
    "reviewAnswer": "Your answer: {answer}",
    "reviewCorrect": "Correct: {answer}"
  },
  "active": {
    "subtitle": "Pick the best answer and keep going.",
    "hearts": "Hearts",
    "progress": "Question {current} of {total}",
    "correct": "Correct!",
    "incorrect": "Not quite — try the next one.",
    "questionImageAlt": "Question image",
    "finishRound": "Finish round",
    "nextQuestion": "Next question"
  },
  "bossBattle": {
    "finalBossBadge": "FINAL BOSS BATTLE",
    "midBossBadge": "MID-BOSS CHALLENGE",
    "finalBossTitle": "Guardian of {category}",
    "midBossTitle": "Trial of {category}",
    "finalBossSubtitle": "Answer questions correctly to deplete the Boss HP and win the path trophy!",
    "midBossSubtitle": "Defeat the guardian checkpoint to unlock the next chapter of your journey!",
    "bossHp": "Boss HP",
    "defeated": "Boss Defeated!",
    "victoryTitle": "VICTORY! Boss Defeated!",
    "victorySubtitle": "You conquered the challenge and earned maximum honor!",
    "failedTitle": "The Boss Was Too Tough!",
    "failedSubtitle": "Don't give up! Rest up, study the questions, and challenge the boss again."
  }
}
